import TomSelect from 'tom-select'

document.querySelectorAll('.wpcf7-select').forEach((el) => {
  const select = el as HTMLSelectElement
  const emptyOption = '<option value="" selected="selected" disabled></option>'
  select.insertAdjacentHTML('afterbegin', emptyOption)

  let settings = {
    create: false,
    hidePlaceholder: true,
    allowEmptyOption: true,
    onChange: () => {
      if (el.classList.contains('project-type-js')) {
        updateCtaBtn(el as HTMLSelectElement, '')
      }
      if (el.classList.contains('customer-type-js')) {
        updateCtaBtn('', el as HTMLSelectElement)
      }
    },
    onDropdownOpen: () => {
      select.previousElementSibling?.classList.add('changed')
    },
    onDropdownClose: () => {
      select.value ? select.previousElementSibling?.classList.add('changed') : select.previousElementSibling?.classList.remove('changed')
    },

  }
  new TomSelect(select, settings)

  function updateCtaBtn(selectProjectType, selectCustomerType) {
    const ctaBtn = document.querySelector('.hero-section .cta-btn-js') as HTMLLinkElement

    if (ctaBtn) {
      const url = new URL(ctaBtn.href);
      const projectTypeValue = selectProjectType?.value || '';
      const customerTypeValue = selectCustomerType?.value || '';
      if (projectTypeValue) {
        selectProjectType.classList.add('is-selected')
        url.searchParams.set('project-type', projectTypeValue);
      }
      if (customerTypeValue) {
        selectCustomerType.classList.add('is-selected')
        url.searchParams.set('customer-type', customerTypeValue);
      }
      ctaBtn.href = url.toString();
    }
  }

})
if (window.location.search) {
  const urlParams = new URLSearchParams(window.location.search);

  const projectType = urlParams.get('project-type');
  const customerType = urlParams.get('customer-type');

  const capitalizeFirstLetter = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  if (projectType) {
    const projectTypeSelect = document.querySelector('select[name="project-type"].tomselected') as unknown as TomSelect;
    if (projectTypeSelect) {

      projectTypeSelect.value = capitalizeFirstLetter(projectType);
      projectTypeSelect.tomselect.setValue(projectTypeSelect.value);
      projectTypeSelect.previousElementSibling?.classList.add('changed');
    }
  }

  if (customerType) {
    const customerTypeSelect = document.querySelector('select[name="customer-type"].tomselected') as unknown as TomSelect;
    if (customerTypeSelect) {
      customerTypeSelect.value = capitalizeFirstLetter(customerType);
      customerTypeSelect.tomselect.setValue(customerTypeSelect.value);
      customerTypeSelect.previousElementSibling?.classList.add('changed');
    }
  }
}
const privacyCheckboxes = document.querySelectorAll('.form-privacy input[type="checkbox"]')
if (privacyCheckboxes && privacyCheckboxes.length > 0) {
  privacyCheckboxes.forEach((privacyCheckbox) => {
    const checkbox = privacyCheckbox as HTMLInputElement
    const submitButton = document.querySelector('.form-privacy input[type="submit"]') as HTMLInputElement
    submitButton.disabled = false
    // checkbox.addEventListener('change', (e) => {
    //   const submitButton = document.querySelector('.form-privacy input[type="submit"]') as HTMLInputElement
    //   checkbox.checked ? checkbox.classList.add('checked') : checkbox.classList.remove('checked')
    //   if (submitButton) {
    //     submitButton.disabled = !checkbox.checked
    //   }
    // })
  })
}


document.addEventListener(
  'wpcf7invalid',
  function (event) {
    //console.log(event.detail.apiResponse.invalid_fields)
    const errorMessages = event.detail.apiResponse.invalid_fields

    errorMessages.forEach((errorMessage) => {
      const formField = document.querySelector(
        '[name="' + errorMessage.field + '"]'
      ) as HTMLInputElement
      if (formField) {
        let parentElement: HTMLDivElement | null = null

        if (formField.type && formField.type.toLowerCase() !== 'checkbox') {
          parentElement = formField.parentNode as HTMLDivElement
        } else {
          parentElement = formField.closest('div') as HTMLDivElement
        }

        const span = document.createElement('span')
        span.classList.add('error-message')
        span.textContent = errorMessage.message
        parentElement?.appendChild(span)
      }
    })
  },
  false
)

const tomselectedHiddenInputs = document.querySelectorAll('.ts-control > input');
if (tomselectedHiddenInputs) {
  tomselectedHiddenInputs.forEach((input) => {
    input.setAttribute('readonly', 'true');
    input.setAttribute('type', 'hidden');
  });
}

// document dom loaded
document.addEventListener('DOMContentLoaded', () => {
  const selectLabelProjectType = document.querySelector('label[for="project-type-ts-control"]') as HTMLLabelElement;
  const selectLabelCustomType = document.querySelector('label[for="custom-type-ts-control"]') as HTMLLabelElement;
  if (selectLabelProjectType) {
    selectLabelProjectType.setAttribute('for', 'project-type');
    selectLabelProjectType.htmlFor = 'project-type';
  }
  if (selectLabelCustomType) {
    selectLabelCustomType?.setAttribute('for', 'custom-type');
    selectLabelCustomType.htmlFor = 'custom-type';
  }
});